var _defs, _circle, _circle2, _polyline, _line, _polyline2, _polyline3, _circle3, _rect, _path, _rect2, _polygon, _rect3, _polygon2, _rect4, _rect5, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _polygon3, _polygon4, _polygon5, _polygon6, _circle4, _path18, _path19, _path20, _path21, _path22, _path23, _line2, _line3, _line4, _path24, _path25, _line5, _line6, _line7, _path26, _g, _polygon7, _polygon8, _polygon9, _polygon0;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMercurioEmptyStateIntegraciones = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 288,
    viewBox: "0 0 346 288",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 173.57,
    cy: 144,
    r: 134.92,
    fill: "none"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 173.57,
    cy: 144,
    r: 134.92,
    fill: "#c6f1e1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.57,
    cy: 144,
    r: 134.92,
    fill: "none"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "146.86 228 40.4 228 40.4 179.54",
    fill: "none",
    stroke: "#008675",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    strokeDasharray: "4 6"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 276.17,
    y1: 198,
    x2: 200.18,
    y2: 198,
    fill: "none",
    stroke: "#008675",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    strokeDasharray: "4 6"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "242.87 50.33 299.46 50.33 299.46 181.47",
    fill: "none",
    stroke: "#008675",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    strokeDasharray: "4 6"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "70.4 123.78 70.4 30.33 130.29 30.33",
    fill: "none",
    stroke: "#008675",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    strokeDasharray: "4 6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.93,
    cy: 102.86,
    r: 2.19,
    fill: "#00ffc7",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 104.02,
    y: 20.16,
    width: 138.38,
    height: 91.51,
    rx: 4.61,
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.61,105.76H248.53v2.38a5.63,5.63,0,0,1-5.63,5.63H104.24a5.63,5.63,0,0,1-5.63-5.63v-2.38Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 107.73,
    y: 23.8,
    width: 130.56,
    height: 77.28,
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "159.57 104.9 161.43 107.86 187.6 107.86 189.33 104.9 159.57 104.9",
    fill: "#262626",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 110.42,
    y: 26.42,
    width: 125.45,
    height: 74.41,
    rx: 1.03,
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "235.74 100.94 110.29 100.94 110.42 31.98 235.74 31.98 235.74 100.94",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 115.78,
    y: 48.01,
    width: 109.89,
    height: 12.31,
    fill: "#c6f1e1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 115.78,
    y: 73.5,
    width: 109.89,
    height: 12.31,
    fill: "#c6f1e1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126,29.29a1,1,0,1,1-1-1h0a1,1,0,0,1,1,1Z",
    fill: "#00ffc7",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.39,29.29a1,1,0,1,1-1-1h0a1,1,0,0,1,1,1Z",
    fill: "#00ffc7",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M121.07,29.29a1,1,0,1,1-1-1h0A1,1,0,0,1,121.07,29.29Z",
    fill: "#00ffc7",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M241.2,104.9s-30.71.09-68.58.09-68.6,0-68.6-.09,30.69-.09,68.6-.09S241.2,104.85,241.2,104.9Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M197.78,56.54H143.62a2.24,2.24,0,0,1-2.4-2h0a2.24,2.24,0,0,1,2.4-2h54.16a2.24,2.24,0,0,1,2.4,2h0A2.24,2.24,0,0,1,197.78,56.54Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M163.74,56.54H143.05a1.94,1.94,0,0,1-1.83-2h0a1.94,1.94,0,0,1,1.83-2h20.69a1.39,1.39,0,0,1,1.31,1.46v1.16a1.39,1.39,0,0,1-1.31,1.46Z",
    fill: "#00ffc7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M163.74,56.54H143.05a1.94,1.94,0,0,1-1.83-2h0a1.94,1.94,0,0,1,1.83-2h20.69a1.39,1.39,0,0,1,1.31,1.46v1.16a1.39,1.39,0,0,1-1.31,1.46Z",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M197.78,82H143.62a2.24,2.24,0,0,1-2.4-2h0a2.25,2.25,0,0,1,2.4-2h54.16a2.26,2.26,0,0,1,2.4,2h0A2.25,2.25,0,0,1,197.78,82Z",
    fill: "#00ffc7",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M197.78,94.35H143.62a2.24,2.24,0,0,1-2.4-2h0a2.24,2.24,0,0,1,2.4-2h54.16a2.25,2.25,0,0,1,2.4,2h0A2.25,2.25,0,0,1,197.78,94.35Z",
    fill: "#00ffc7",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M197.78,69.73H143.62a2.24,2.24,0,0,1-2.4-2h0a2.24,2.24,0,0,1,2.4-2h54.16a2.24,2.24,0,0,1,2.4,2h0A2.24,2.24,0,0,1,197.78,69.73Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M170.78,69.73H143.62a2.24,2.24,0,0,1-2.4-2h0a2.24,2.24,0,0,1,2.4-2h27.16a1.6,1.6,0,0,1,1.72,1.46v1.16a1.61,1.61,0,0,1-1.72,1.46Z",
    fill: "#00ffc7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M170.78,69.73H143.62a2.24,2.24,0,0,1-2.4-2h0a2.24,2.24,0,0,1,2.4-2h27.16a1.6,1.6,0,0,1,1.72,1.46v1.16a1.61,1.61,0,0,1-1.72,1.46Z",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M214.36,53.64l-1.43-1.78a.17.17,0,0,0-.24,0,.13.13,0,0,0-.05.07l-.23.6a3.51,3.51,0,0,0-3.9,1.45l1,.68A2.22,2.22,0,0,1,212,53.55l-.2.53a.17.17,0,0,0,.09.22.14.14,0,0,0,.09,0l2.27-.37a.17.17,0,0,0,.13-.2A.18.18,0,0,0,214.36,53.64Z",
    fill: "#34806b"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M213.86,55.76a2.23,2.23,0,0,1-2.52,1l.29-.69a.11.11,0,0,0,0-.11h-.05l-2.58.35a.08.08,0,0,0-.07.09s0,0,0,0l1.57,2.08a.08.08,0,0,0,.11,0l0,0,.31-.74a3.51,3.51,0,0,0,3.89-1.33Z",
    fill: "#34806b"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M214.36,64.19l-1.43-1.78a.17.17,0,0,0-.24,0,.22.22,0,0,0-.05.08l-.23.6a3.51,3.51,0,0,0-3.9,1.45l1,.68A2.22,2.22,0,0,1,212,64.1l-.2.52a.18.18,0,0,0,.09.23.14.14,0,0,0,.09,0l2.27-.37a.17.17,0,0,0,.13-.2A.18.18,0,0,0,214.36,64.19Z",
    fill: "#34806b"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M213.86,66.31a2.22,2.22,0,0,1-2.52,1l.29-.68a.11.11,0,0,0,0-.11h-.05L209,66.9a.08.08,0,0,0-.07.09s0,0,0,0l1.57,2.08a.08.08,0,0,0,.11,0l0,0,.31-.74A3.51,3.51,0,0,0,214.81,67Z",
    fill: "#34806b"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M211.29,83.33a.63.63,0,0,1-.39-.13l-2.1-1.46a.7.7,0,0,1-.17-1,.69.69,0,0,1,1-.16l1.5,1,2.78-4.62a.67.67,0,0,1,.93-.24.69.69,0,0,1,.24.94L211.88,83a.69.69,0,0,1-.45.31Z",
    fill: "#34806b"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M211.29,94.19a.69.69,0,0,1-.39-.12l-2.1-1.47a.69.69,0,0,1-.17-.95.68.68,0,0,1,1-.17l1.5,1,2.78-4.62a.68.68,0,0,1,1.17.7l-3.15,5.25a.71.71,0,0,1-.45.32Z",
    fill: "#34806b"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "129.56 52.4 129.56 50.2 123.25 50.2 123.25 58.12 135.12 58.12 135.12 52.4 129.56 52.4",
    fill: "#00ffc7",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "129.56 64.71 129.56 62.51 123.25 62.51 123.25 70.42 135.12 70.42 135.12 64.71 129.56 64.71",
    fill: "#00ffc7",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "129.56 77.9 129.56 75.7 123.25 75.7 123.25 83.61 135.12 83.61 135.12 77.9 129.56 77.9",
    fill: "#00ffc7",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "129.56 90.2 129.56 88.01 123.25 88.01 123.25 95.92 135.12 95.92 135.12 90.2 129.56 90.2",
    fill: "#00ffc7",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.55,
    cy: 164,
    r: 41.77,
    transform: "matrix(0.96, -0.28, 0.28, 0.96, -43.6, 22.04)",
    fill: "#00ffc7",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2,186.31l-36.37.17a3.74,3.74,0,0,1-3.72-4.24L40.3,144.7A3.72,3.72,0,0,1,44,141.48l25.65-.12a3.73,3.73,0,0,1,3.71,3.19L78.87,182A3.73,3.73,0,0,1,75.2,186.31Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M64,146.74v-2.85a7.14,7.14,0,0,0-14.28.06l0,2.86",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M64.68,147.45a.71.71,0,0,1-.71.72.73.73,0,0,1-.72-.71.72.72,0,1,1,1.43,0Z",
    fill: "#262626",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4,147.52a.71.71,0,1,1-.71-.71A.71.71,0,0,1,50.4,147.52Z",
    fill: "#262626",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M313.58,172.16h0a2.31,2.31,0,0,0,3.35,2.45h0a2.32,2.32,0,0,1,3.21,2.95h0a2.31,2.31,0,0,0,2.72,3.14h0a2.31,2.31,0,0,1,2.47,3.59h0a2.31,2.31,0,0,0,2,3.66h0a2.32,2.32,0,0,1,1.61,4.06h0a2.31,2.31,0,0,0,1.09,4h0a2.32,2.32,0,0,1,.67,4.31h0a2.32,2.32,0,0,0,.17,4.16h0a2.32,2.32,0,0,1-.31,4.35h0a2.31,2.31,0,0,0-.76,4.08h0a2.31,2.31,0,0,1-1.27,4.17h0a2.32,2.32,0,0,0-1.65,3.82h0a2.31,2.31,0,0,1-2.16,3.78h0a2.32,2.32,0,0,0-2.45,3.36h0a2.31,2.31,0,0,1-3,3.21h0a2.31,2.31,0,0,0-3.14,2.72h0a2.31,2.31,0,0,1-3.59,2.47h0a2.31,2.31,0,0,0-3.66,2h0a2.32,2.32,0,0,1-4.06,1.61h0a2.31,2.31,0,0,0-4,1.09h0a2.32,2.32,0,0,1-4.31.66h0a2.32,2.32,0,0,0-4.16.17h0a2.32,2.32,0,0,1-4.35-.31h0a2.31,2.31,0,0,0-4.08-.76h0a2.32,2.32,0,0,1-4.17-1.27h0A2.32,2.32,0,0,0,275.9,238h0a2.32,2.32,0,0,1-3.79-2.17h0a2.32,2.32,0,0,0-3.36-2.46h0a2.31,2.31,0,0,1-3.21-2.95h0a2.31,2.31,0,0,0-2.72-3.14h0a2.32,2.32,0,0,1-2.47-3.6h0a2.31,2.31,0,0,0-2-3.67h0a2.31,2.31,0,0,1-1.61-4.05h0a2.32,2.32,0,0,0-1.09-4h0a2.31,2.31,0,0,1-.66-4.3h0a2.31,2.31,0,0,0-.17-4.15h0a2.32,2.32,0,0,1,.31-4.35h0a2.32,2.32,0,0,0,.76-4.09h0a2.32,2.32,0,0,1,1.27-4.18h0a2.31,2.31,0,0,0,1.64-3.81h0a2.32,2.32,0,0,1,2.17-3.78h0a2.31,2.31,0,0,0,2.46-3.35h0a2.32,2.32,0,0,1,3-3.21h0a2.31,2.31,0,0,0,3.14-2.72h0a2.32,2.32,0,0,1,3.6-2.47h0a2.32,2.32,0,0,0,3.67-2h0a2.31,2.31,0,0,1,4.05-1.61h0a2.32,2.32,0,0,0,4-1.09h0a2.32,2.32,0,0,1,4.31-.67h0a2.31,2.31,0,0,0,4.15-.18h0a2.32,2.32,0,0,1,4.35.31h0a2.31,2.31,0,0,0,4.09.76h0a2.32,2.32,0,0,1,4.18,1.27h0a2.31,2.31,0,0,0,3.81,1.65h0A2.32,2.32,0,0,1,313.58,172.16Z",
    fill: "#00ffc7",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M299.81,194.93c.26.36-.28,17.62-.28,17.62l-36,.93s-.9-9.62,3.07-10.48l21.48-11.13Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 281.22,
    y1: 196.4,
    x2: 283.47,
    y2: 200.03,
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 277.98,
    y1: 198.07,
    x2: 280.24,
    y2: 201.7,
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 275.04,
    y1: 199.64,
    x2: 277.29,
    y2: 203.26,
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M289.33,203.23a3.14,3.14,0,1,0,3.13-3.14A3.13,3.13,0,0,0,289.33,203.23Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M319.42,195.19c.27.36-.27,17.63-.27,17.63l-36,.92s-.91-9.62,3.06-10.48l21.48-11.13Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 300.83,
    y1: 196.66,
    x2: 303.09,
    y2: 200.29,
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 297.6,
    y1: 198.33,
    x2: 299.85,
    y2: 201.96,
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 294.65,
    y1: 199.9,
    x2: 296.91,
    y2: 203.53,
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M308.94,203.5a3.14,3.14,0,1,0,3.14-3.14A3.14,3.14,0,0,0,308.94,203.5Z",
    fill: "#00ffc7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.26,208.92c.41,1.3-19.45,2.7-20.85,2.57a8.71,8.71,0,0,1-4.3-2c-4.43-3.41-2.32-6.65-1.08-6.74l22.22-.5a3.15,3.15,0,0,1,3,2.21Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.41,198.29c.37,1.31-23,3.51-24.17,3.61s-3.14-.27-5.71-2.33c-5-4-2.62-7.62-1.38-7.69l5.92-.3c1.24-.06,24.18-2.49,24.55-1.18Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.13,187.38c.5,1.27,1.28,1.56.43,2.52,0,0-15.83,1.23-17.52,1.41-1.42.15-3.45-.2-6.15-2-5.93-3.92-3.82-8.19-2.59-8.37l7.08-1c1.22-.18,14.63-1.91,15.13-.65Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.33,210.07s-27,27.38-8.35,59.28c7,11.9,10.7-5.83,10.7-5.83l22.69-37.24Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.15,274.71c5.13-12.27,12.53-30.84,18.84-40.64s4.79-10.8,7.3-20.18c1.52-9.32-1.45-14.9-2.2-21.77s-11.1-11.51-13-12c-7.27-2-30.49-4.67-32.41-1.11-2.46,8-3,23.61-5.4,30.51S156,220,162,224.21c3.61,2.55,8.27,2.9,12.43,4.28A57.92,57.92,0,0,1,170.87,241c-1.43,3.54-3.25,7.82-4.5,11.24-1.43,3.92-.11,7.23,2.49,10,4.2,4,7.85,8.82,12.29,12.51",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.68,163l-34.09-9.1a7.3,7.3,0,0,0-8.93,5.17l-17.25,64.64a7.3,7.3,0,0,0,5.17,8.93l34.09,9.1a7.3,7.3,0,0,0,8.93-5.17l17.25-64.64A7.29,7.29,0,0,0,200.68,163Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.32,
    y: 170.59,
    width: 81.5,
    height: 49.87,
    rx: 7.3,
    transform: "translate(-57.5 316.21) rotate(-75.06)",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.53,
    y: 170.05,
    width: 59.22,
    height: 42.98,
    transform: "matrix(0.26, -0.97, 0.97, 0.26, -52.85, 314.27)",
    fill: "#34806b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,187.1a15.56,15.56,0,1,0,16.6-14.44A15.55,15.55,0,0,0,164,187.1Z",
    fill: "#fafafa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.45,183.59l17.24-.82q-1.19,5.34-2.38,10.7L176,194c-.65,0-1.14,0-1.13.51s.54.48,1.25.44l10.21-.48c.77,0,1.85-.18,1.5.66-.17.41-1,.21-1.57.3a2.12,2.12,0,0,1-.71,2.73,2,2,0,0,1-2.7-2.57l-4.27.21a6.87,6.87,0,0,1,.24.87c.2,2.56-3.86,2.85-3.84.15a2.56,2.56,0,0,1,.19-.86,2.19,2.19,0,0,1-.83-.38,1.61,1.61,0,0,1,.23-2.36c-1.29-4-2.61-8-3.88-12-.69,0-1.35-.1-2.24-.16-.62,0-1.84.1-1.95-.44-.06-.3.18-.61.4-.6.74,0,1.39.1,2.24.16a7.27,7.27,0,0,1,2.2.2c.28.2.47,1.26.58,1.59C172.09,182.52,172.27,183,172.45,183.59Zm.9,2.85,2.65-.13c-.09-.67-.25-1.26-.36-1.91l-2.88.14C172.94,185.2,173.18,185.78,173.35,186.44Zm3.65-.18,3.23-.15c0-.64-.06-1.28-.1-1.92l-3.53.17C176.75,185,176.85,185.65,177,186.26Zm4.13-2.12a18.07,18.07,0,0,0,.06,1.92l3.34-.16c0-.66.14-1.27.17-1.93Zm4.61-.22a16,16,0,0,0-.25,1.94l2.57-.13c.11-.67.29-1.28.41-1.94Zm-11.31,5.81,2.23-.1c-.12-.83-.29-1.59-.46-2.37-.83.07-1.77,0-2.53.16C174,188.16,174.18,189,174.43,189.73Zm2.77-2.52c.12.83.3,1.59.46,2.37l2.73-.13-.12-2.38Zm4.07-.19c-.05.72.06,1.6.08,2.38l2.84-.13c.06-.82.16-1.6.23-2.4Zm4.11-.2c-.06.82-.16,1.6-.23,2.4l2.15-.1c.17-.81.34-1.62.54-2.41Zm-9.86,6.25,1.84-.09c-.19-.78-.31-1.63-.5-2.4l-2.07.1C174.93,191.42,175.3,192.27,175.52,193.07Zm2.38-2.54a20.83,20.83,0,0,0,.42,2.4l2.23-.1-.12-2.42Zm3.49-.17.12,2.42,2.34-.11c0-.83.22-1.69.19-2.43Zm3.73-.18a16.75,16.75,0,0,0-.31,2.44l1.73-.08c.14-.81.43-1.69.5-2.45ZM176,196.55a1,1,0,1,0,.71-.61A.94.94,0,0,0,176,196.55Zm7.68-.37a1,1,0,0,0,.91,1.27c1.37,0,1.27-2.23-.2-1.88A1,1,0,0,0,183.63,196.18Z",
    fill: "#262626",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.83,196.39a.44.44,0,0,1,.51.25c.19.54-.26.77-.62.68S176.32,196.47,176.83,196.39Z",
    fill: "#262626",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.51,196a.42.42,0,0,1,.51.25c.33.93-1.12.85-.92,0C184.12,196.22,184.23,196.07,184.51,196Z",
    fill: "#262626",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.31,195.61c1.62.45,2.44.52,4.19,1,3,.75,4.07.36,7.06,2.7,10.65,8.32,9.71,10,12.63,24.61.85,4.26.28,5.42-.17,8.09-2.14,12.77-6.81,26.45-8.09,38.68s.75,22.54.16,34.39c-11.67,1.53-23.85,3.43-35.66,5.09-.26-2.81-.33-5.7-.67-8.53-1-7.84,2.25-12.85-1-20.09-.15-.71.09-4.56,0-5.21-.88-6.24-3.86-7.94-2.49-14.82,3.42-17.27,8.89-29.53,26.16-34.33,3.27-.91,3.54-2.74,3.93-5.16a29.67,29.67,0,0,0-.17-9.13c-.4-2.31-2.16-3.35-4.51-4.05-3.46-1-8.08-3.85-9.48-7s-1.82-3.28-1.82-6.1c0-.05.06,0,0-.05h0s0,0,0-.07a4.37,4.37,0,0,1,.17-.62h0a3.58,3.58,0,0,1,.72-1.08",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.32,193.89l0,0a3.19,3.19,0,0,1,.47-.35.59.59,0,0,1,.14-.06,3.3,3.3,0,0,1,.43-.19,2.5,2.5,0,0,1,.29-.05,2.63,2.63,0,0,1,.34-.06,3.54,3.54,0,0,1,.45,0h.21a4.15,4.15,0,0,1,.7.2l3.64,1.48c.39.16.63.23,1,.36l1.23.3",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.53,255.82l-7.67,87.72c.73.53,58.23-3.87,58.23-3.87l-7.46-83.85",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "238.64 198 231.01 193.59 231.01 202.41 238.64 198",
    fill: "#00ffc7"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "70.4 77.61 66 85.24 74.81 85.24 70.4 77.61",
    fill: "#00ffc7"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.36 228 97.99 232.41 97.99 223.59 90.36 228",
    fill: "#00ffc7"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    points: "299.46 71.28 295.06 78.91 303.87 78.91 299.46 71.28",
    fill: "#00ffc7"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMercurioEmptyStateIntegraciones, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mercurio_empty_state_integraciones.1f22844c.svg";
export { ForwardRef as ReactComponent };